import { create } from "zustand";

export const useAuth = create((set) => ({
  authorized: !!localStorage.getItem("bnk_jwt"),
  username: !!localStorage.getItem("bnk_username"), 

  signin: (pu, token) => {
    localStorage.setItem("bnk_jwt", token);
    localStorage.setItem("bnk_username", pu);
    set({
      authorized: true,
      username: pu,
    });
  },

  signout: () => {
    localStorage.removeItem("bnk_jwt");
    localStorage.removeItem("bnk_username");
    set({
      authorized: false,
      username: null,
    });
  },

  updateUser: (upd) => set((state) => ({
    username: state.username ? { ...state.username, ...upd } : null
  }))
}));